/**
 * A global namespace for `abort` event.
 */
const abortEvent = 'abort';
export default abortEvent;
